<template>
  <div class="user-manage-container">
    <div class="sticky-search">
   
      <label for="userName">用户名:</label>
      <input type="text" v-model="search.userName" id="userName" :disabled="disableSearch" placeholder="请输入用户名">

      <label for="nickName">用户昵称:</label>
      <input type="text" v-model="search.nickName" id="nickName" :disabled="disableSearch" placeholder="请输入用户昵称">


      <button @click="fetchData" :disabled="loading || disableSearch">{{ loading ? '查询中...' : '查询' }}</button>
      <button @click="openCreateDialog" :disabled="loading || disableSearch" class="create-btn">新增用户</button>
    </div>

    <table>
      <thead class="sticky-header">
        <tr>
          <th>UID</th>
          <th>用户名</th>
          <th>用户昵称</th>
          <th>角色</th>
          <th>上次登录时间</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <!-- 加载中状态 -->
        <tr v-if="loading">
          <td colspan="11" style="text-align: center; padding: 20px;">
            <span v-if="$loading">
              <el-icon>
                <Loading />
              </el-icon> 加载中...
            </span>
            <span v-else>加载中...</span>
          </td>
        </tr>

        <!-- 错误状态 -->
        <tr v-else-if="error">
          <td colspan="11" style="text-align: center; padding: 20px; color: #f56c6c;">
            {{ error }}
          </td>
        </tr>

        <!-- 无数据状态 -->
        <tr v-else-if="!hasData">
          <td colspan="11" style="text-align: center; padding: 20px;">
            暂无数据
          </td>
        </tr>

        <!-- 数据列表 -->
        <tr v-else v-for="item in filteredData" :key="item.uid" :class="{ 'prohibited-row': item.prohibitLogin }">
          <td>{{ item.uid || '-' }}</td>
          <td>{{ item.userName || '-' }}</td>
          <td>{{ item.nickName || '-' }}</td>
          <td>
            <!-- <span v-if="item.roleType === 0">用户</span>
            <span v-else-if="item.roleType === 1">管理员</span>
            <span v-else>-</span> -->
            <span v-if="item.isAdmin" style="margin-left: 5px; color: #1890ff;">超管</span>
            <span v-else-if="item.roleType === 1">管理员</span>
            <span v-else-if="item.roleType === 0">用户</span>
            <span v-else>-</span>
          </td>
          <td>{{ formatDate(item.lastLoginUnix) }}</td>
          <td>
            <span v-if="item.prohibitLogin">禁用</span>
            <span v-else>正常</span>
          </td>
          <td>
            <button @click="openEditDialog(item)" class="edit-btn" :disabled="disableSearch">编辑</button>
            <button @click="openChangePasswordDialog(item)" class="change-password-btn" :disabled="disableSearch">修改密码</button>
            <button v-if="loginUser.isAdmin" @click="toggleProhibit(item)"
              :class="['prohibit-btn', item.prohibitLogin ? 'enable-btn' : 'disable-btn']" :disabled="disableSearch">
              {{ item.prohibitLogin ? '启用' : '禁用' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 分页组件 -->
    <div class="pagination-container" v-if="pagination.total > 0">
      <div class="page-size-selector">
        <span>每页显示：</span>
        <el-select v-model="pagination.limit" @change="onLimitChange" :disabled="loading" size="small" style="width: 100px">
          <el-option label="5条" value="5"></el-option>
          <el-option label="10条" value="10"></el-option>
          <el-option label="20条" value="20"></el-option>
          <el-option label="50条" value="50"></el-option>
        </el-select>
      </div>

      <el-pagination
        @size-change="onLimitChange"
        @current-change="changePage"
        :current-page="pagination.pageNo"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pagination.limit"
        layout="prev, pager, next"
        :total="pagination.total"
        :disabled="loading">
      </el-pagination>
    </div>

    <!-- 编辑权限弹窗 -->
    <div v-if="showDialog" class="dialog-overlay">
      <div class="dialog-content">
        <div class="dialog-header">
          <h3>编辑用户</h3>
          <button class="close-btn" @click="closeDialog">×</button>
        </div>
        <div class="dialog-body">
          <form @submit.prevent="confirmUpdate">
            <div class="form-group">
              <label for="editUserName">用户名:</label>
              <input 
                type="text" 
                id="editUserName" 
                :value="editingUser.userName || ''" 
                disabled
                class="disabled-input"
              >
            </div>
            <div class="form-group">
              <label for="editNickName">用户昵称 *:</label>
              <input 
                type="text" 
                id="editNickName" 
                v-model="editingUser.nickName" 
                required
                placeholder="请输入用户昵称"
              >
            </div>
            <div class="form-group">
              <label for="editRoleType">角色类型 *:</label>
              <select 
                id="editRoleType" 
                v-model="editingUser.roleType" 
                required
                class="role-select"
              >
                <option value="0">用户</option>
                <option value="1">管理员</option>
              </select>
            </div>
            <div class="form-group">
              <label for="editIsAdmin">是否为超管 *:</label>
              <select 
                id="editIsAdmin" 
                v-model="editingUser.isAdmin" 
                required
                class="role-select"
              >
                <option value="0">否</option>
                <option value="1">是</option>
              </select>
            </div>
          </form>
        </div>
        <div class="dialog-footer">
          <button @click="closeDialog" :disabled="updating">取消</button>
          <button @click="confirmUpdate" :disabled="updating" class="confirm-btn">
            {{ updating ? '更新中...' : '确认' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 新增用户弹窗 -->
    <div v-if="showCreateDialog" class="dialog-overlay">
      <div class="dialog-content">
        <div class="dialog-header">
          <h3>新增用户</h3>
          <button class="close-btn" @click="closeCreateDialog">×</button>
        </div>
        <div class="dialog-body">
          <form @submit.prevent="confirmCreateUser">
            <div class="form-group">
              <label for="createUserName">用户名 *:</label>
              <input
                type="text"
                id="createUserName"
                v-model="creatingUser.userName"
                required
                placeholder="请输入用户名"
              >
            </div>
            <div class="form-group">
              <label for="createNickName">用户昵称 *:</label>
              <input
                type="text"
                id="createNickName"
                v-model="creatingUser.nickName"
                required
                placeholder="请输入用户昵称"
              >
            </div>
            <div class="form-group">
              <label for="createPassword">密码 *:</label>
              <input
                type="password"
                id="createPassword"
                v-model="creatingUser.password"
                required
                placeholder="请输入密码"
                minlength="6"
              >
            </div>
            <div class="form-group">
              <label for="createRoleType">角色类型 *:</label>
              <select
                id="createRoleType"
                v-model="creatingUser.roleType"
                required
                class="role-select"
              >
                <option value="0">用户</option>
                <option value="1">管理员</option>
              </select>
            </div>
            <div class="form-group">
              <label for="createIsAdmin">是否为超管 *:</label>
              <select
                id="createIsAdmin"
                v-model="creatingUser.isAdmin"
                required
                class="role-select"
              >
                <option value="0">否</option>
                <option value="1">是</option>
              </select>
            </div>
          </form>
        </div>
        <div class="dialog-footer">
          <button @click="closeCreateDialog" :disabled="updating">取消</button>
          <button @click="confirmCreateUser" :disabled="updating" class="confirm-btn">
            {{ updating ? '创建中...' : '确认' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 修改密码弹窗 -->
    <div v-if="showChangePasswordDialog" class="dialog-overlay">
      <div class="dialog-content">
        <div class="dialog-header">
          <h3>修改密码</h3>
          <button class="close-btn" @click="closeChangePasswordDialog">×</button>
        </div>
        <div class="dialog-body">
          <form @submit.prevent="confirmChangePassword">
            <div class="form-group">
              <label for="changePasswordUserName">用户名:</label>
              <input
                type="text"
                id="changePasswordUserName"
                :value="changingPasswordUser.userName"
                disabled
                class="disabled-input"
              >
            </div>
            <div class="form-group">
              <label for="changePassword">新密码 *:</label>
              <input
                type="password"
                id="changePassword"
                v-model="changingPasswordUser.password"
                required
                placeholder="请输入新密码"
                minlength="6"
              >
            </div>
            <div class="form-group">
              <label for="confirmPassword">确认密码 *:</label>
              <input
                type="password"
                id="confirmPassword"
                v-model="changingPasswordUser.confirmPassword"
                required
                placeholder="请再次输入密码"
                minlength="6"
              >
            </div>
          </form>
        </div>
        <div class="dialog-footer">
          <button @click="closeChangePasswordDialog" :disabled="updating">取消</button>
          <button @click="confirmChangePassword" :disabled="updating" class="confirm-btn">
            {{ updating ? '修改中...' : '确认' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// 导入MD5加密函数
import { md5 } from '@/utils/md5.js';

export default {
  name: 'UserManage',
    data() {
      return {
        loginUser: {
          uname: "",
          uid: null,
        },
        search: {
          userName: '',
          nickName: ''
        },
      items: [],
      filteredData: [],
      loading: false, // 添加加载状态
      error: null, // 添加错误状态
      showDialog: false,
      showCreateDialog: false, // 新增用户弹窗状态
      showChangePasswordDialog: false, // 修改密码弹窗状态
      editingUser: {
        uid: null,
        userName: '',
        nickName: '',
        roleType: 0,
        isAdmin: 0, // 是否为管理员：0-否，1-是
      },
      creatingUser: { // 新增用户表单数据
        userName: '',
        nickName: '',
        password: '',
        roleType: 0, // 默认选中用户（0-用户，1-管理员）
        isAdmin: 0, // 是否为管理员：0-否，1-是
      },
      changingPasswordUser: { // 修改密码表单数据
        uid: null,
        userName: '',
        password: '',
        confirmPassword: '',
      },
      updating: false,
      disableSearch: false, // 控制搜索功能禁用状态
      // 分页相关数据
      pagination: {
        pageNo: 1,
        limit: 10,
        total: 0
      },
      _apiPages: 0 // 用于存储API返回的总页数
    }
  },

  // 计算属性 - 可以添加一些派生数据
  computed: {
    hasData() {
      return this.filteredData && this.filteredData.length > 0;
    },
    totalPages() {
      // 调试信息
      console.log('totalPages计算:', {
        _apiPages: this._apiPages,
        total: this.pagination.total,
        limit: this.pagination.limit,
        calculated: Math.ceil(this.pagination.total / this.pagination.limit)
      });
      
      // 优先使用API返回的页数，如果有的话
      if (this._apiPages && this._apiPages > 0) {
        return this._apiPages;
      }
      // 确保不会返回NaN或无限大
      if (!this.pagination.total || !this.pagination.limit) {
        return 1;
      }
      return Math.max(1, Math.ceil(this.pagination.total / this.pagination.limit));
    },
  },

  // 监听分页变化
  watch: {
    // 当每页条数改变时，重置到第一页
    'pagination.limit'(newLimit, oldLimit) {
      if (newLimit !== oldLimit && this.pagination.pageNo !== 1) {
        this.pagination.pageNo = 1;
      }
    }
  },

  // 组件销毁前的清理工作
  beforeDestroy() {
    // 取消可能正在进行的请求
    if (this._axiosRequest) {
      this._axiosRequest.cancel('组件已销毁');
    }
  },
  methods: {
    /**
     * 切换页码
     */
    changePage(newPage) {
      console.log('changePage called:', { newPage, currentPage: this.pagination.pageNo, totalPages: this.totalPages, loading: this.loading });
      if (newPage >= 1 && newPage <= this.totalPages && newPage !== this.pagination.pageNo && !this.loading) {
        this.pagination.pageNo = newPage;
        this.fetchData();
      }
    },

    /**
     * 每页条数改变事件
     */
    onLimitChange() {
      if (!this.loading) {
        this.pagination.pageNo = 1; // 重置到第一页
        this.fetchData();
      }
    },

    /**
     * 检查分页状态（用于调试）
     */
    checkPaginationStatus() {
      return {
        hasNextPage: this.pagination.pageNo < this.totalPages,
        hasPrevPage: this.pagination.pageNo > 1
      };
    },

    /**
     * 格式化时间戳为yyyy-MM-dd hh:mm:ss格式
     */
    formatDate(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000); // 转换为毫秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    /**
     * 打开编辑权限弹窗
     */
    openEditDialog(user) {
      this.editingUser = { 
        uid: user.uid || null,
        userName: user.userName || '',
        nickName: user.nickName || '',
        roleType: user.roleType || 0,
        isAdmin: user.isAdmin ? 1 : 0, // 是否为管理员：0-否，1-是
      };
      this.showDialog = true;
      this.disableSearch = true; // 打开弹窗时禁用搜索
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.showDialog = false;
      this.editingUser = {
        uid: null,
        userName: '',
        nickName: '',
        roleType: 0,
        isAdmin: 0, // 重置为默认值
      };
      this.disableSearch = false; // 关闭弹窗时启用搜索
    },

    /**
     * 打开新增用户弹窗
     */
    openCreateDialog() {
      this.creatingUser = {
        userName: '',
        nickName: '',
        password: '',
        roleType: 0, // 默认选中用户
        isAdmin: 0, // 是否为管理员：0-否，1-是
      };
      this.showCreateDialog = true;
      this.disableSearch = true; // 打开弹窗时禁用搜索
    },

    /**
     * 关闭新增用户弹窗
     */
    closeCreateDialog() {
      this.showCreateDialog = false;
      this.creatingUser = {
        userName: '',
        nickName: '',
        password: '',
        roleType: 0, // 重置为默认值
        isAdmin: 0, // 重置为默认值
      };
      this.disableSearch = false; // 关闭弹窗时启用搜索
    },

    /**
     * 打开修改密码弹窗
     */
    openChangePasswordDialog(user) {
      this.changingPasswordUser = {
        uid: user.uid || null,
        userName: user.userName || '',
        password: '',
        confirmPassword: '',
      };
      this.showChangePasswordDialog = true;
      this.disableSearch = true; // 打开弹窗时禁用搜索
    },

    /**
     * 关闭修改密码弹窗
     */
    closeChangePasswordDialog() {
      this.showChangePasswordDialog = false;
      this.changingPasswordUser = {
        uid: null,
        userName: '',
        password: '',
        confirmPassword: '',
      };
      this.disableSearch = false; // 关闭弹窗时启用搜索
    },

    /**
     * 确认修改密码
     */
    confirmChangePassword() {
      // 表单验证
      if (!this.changingPasswordUser.uid) {
        if (this.$message) {
          this.$message.error('用户UID不能为空');
        }
        return;
      }

      if (!this.changingPasswordUser.password || !this.changingPasswordUser.confirmPassword) {
        if (this.$message) {
          this.$message.error('请填写密码');
        }
        return;
      }

      if (this.changingPasswordUser.password.length < 6) {
        if (this.$message) {
          this.$message.error('密码长度至少为6位');
        }
        return;
      }

      if (this.changingPasswordUser.password !== this.changingPasswordUser.confirmPassword) {
        if (this.$message) {
          this.$message.error('两次输入的密码不一致');
        }
        return;
      }

      this.updating = true;

      // 构建请求数据
      const requestData = {
        uid: this.changingPasswordUser.uid,
        password: md5(this.changingPasswordUser.password),
        confirmPassword: md5(this.changingPasswordUser.confirmPassword),
      };

      // 调用API修改密码
      this.axios.post('/data-serv/manager/user/update-passwd', requestData)
        .then(response => {
          if (response.data.code === 0) {
            // 显示成功提示
            if (this.$message) {
              this.$message.success('密码修改成功');
            }

            // 关闭弹窗
            this.closeChangePasswordDialog();
          } else {
            throw new Error(response.data.msg || '修改密码失败');
          }
        })
        .catch(error => {
          console.error('修改密码失败:', error);
          // 显示错误提示
          if (this.$message) {
            this.$message.error(error.message || '修改密码失败');
          }
        })
        .finally(() => {
          this.updating = false;
        });
    },

    /**
     * 切换用户禁用状态
     */
    toggleProhibit(user) {
      if (!user) return;

      // 二次确认
      const confirmMessage = user.prohibitLogin ? '确定要启用该用户吗？' : '确定要禁用该用户吗？';

      if (this.$confirm) {
        this.$confirm(confirmMessage, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.performProhibitUpdate(user);
          })
          .catch(() => {
            // 用户取消操作，不做处理
          });
      } else {
        // 如果没有$confirm，使用原生confirm
        if (window.confirm(confirmMessage)) {
          this.performProhibitUpdate(user);
        }
      }
    },

    /**
     * 执行禁用状态更新
     */
    performProhibitUpdate(user) {
      this.updating = true;

      // 构建请求数据
      const requestData = {
        uid: user.uid,
        prohibit: !user.prohibitLogin // 如果当前是禁用状态(prohibitLogin=true)，要启用用户，所以传false
      };

      // 调用API更新
      this.axios.post('/data-serv/manager/user/update-prohibit', requestData)
        .then(response => {
          if (response.data.code === 0) {
            // 显示成功提示
            if (this.$message) {
              this.$message.success(user.prohibitLogin ? '用户启用成功' : '用户禁用成功');
            }

            // 刷新数据
            this.fetchData();
          } else {
            throw new Error(response.data.msg || '更新用户状态失败');
          }
        })
        .catch(error => {
          console.error('更新用户状态失败:', error);
          // 显示错误提示
          if (this.$message) {
            this.$message.error(error.message || '更新用户状态失败');
          }
        })
        .finally(() => {
          this.updating = false;
        });
    },

    /**
     * 确认更新用户信息
     */
    confirmUpdate() {
      if (!this.editingUser || !this.editingUser.uid) return;

      // 表单验证
      if (!this.editingUser.nickName || this.editingUser.roleType === undefined || this.editingUser.isAdmin === undefined) {
        if (this.$message) {
          this.$message.error('请填写所有必填字段');
        }
        return;
      }

      this.updating = true;

      // 构建请求数据
      const requestData = {
        uid: this.editingUser.uid,
        nickName: this.editingUser.nickName,
        roleType: parseInt(this.editingUser.roleType),
        isAdmin: parseInt(this.editingUser.isAdmin), // 是否为管理员：0-否，1-是
      };

      // 调用API更新
      this.axios.post('/data-serv/manager/user/update', requestData)
        .then(response => {

          if (response.data.code === 0) {
            // 显示成功提示
            if (this.$message) {
              this.$message.success('用户信息更新成功');
            }

            // 关闭弹窗
            this.closeDialog();
            // 刷新数据
            this.fetchData();
          } else {
            throw new Error(response.data.msg || '更新用户信息失败');
          }

        })
        .catch(error => {
          console.error('更新用户信息失败:', error);
          // 显示错误提示
          if (this.$message) {
            this.$message.error(error.message || '更新用户信息失败');
          }
        })
        .finally(() => {
          this.updating = false;
        });
    },

    /**
     * 确认创建用户
     */
    confirmCreateUser() {
      // 表单验证
      if (!this.creatingUser.userName || !this.creatingUser.nickName || !this.creatingUser.password || 
          this.creatingUser.roleType === undefined || this.creatingUser.isAdmin === undefined) {
        if (this.$message) {
          this.$message.error('请填写所有必填字段');
        }
        return;
      }

      if (this.creatingUser.password.length < 6) {
        if (this.$message) {
          this.$message.error('密码长度至少为6位');
        }
        return;
      }

      this.updating = true;

      // 构建请求数据
      const requestData = {
        userName: this.creatingUser.userName,
        nickName: this.creatingUser.nickName,
        passwd: md5(this.creatingUser.password),
        roleType: parseInt(this.creatingUser.roleType), // 传递选择的角色类型
        isAdmin: parseInt(this.creatingUser.isAdmin), // 是否为管理员：0-否，1-是
      };

      // 调用API创建用户
      this.axios.post('/data-serv/manager/user/create', requestData)
        .then(response => {
          if (response.data.code === 0) {
            // 显示成功提示
            if (this.$message) {
              this.$message.success('用户创建成功');
            }

            // 关闭弹窗
            this.closeCreateDialog();
            // 刷新数据
            this.fetchData();
          } else if (response.data.code === 0) {
            // 兼容旧版本API响应格式
            if (this.$message) {
              this.$message.success('用户创建成功');
            }

            // 关闭弹窗
            this.closeCreateDialog();
            // 刷新数据
            this.fetchData();
          } else {
            throw new Error(response.data.msg || '创建用户失败');
          }
        })
        .catch(error => {
          console.error('创建用户失败:', error);
          // 显示错误提示
          if (this.$message) {
            this.$message.error(error.message || '创建用户失败');
          }
        })
        .finally(() => {
          this.updating = false;
        });
    },

    /**
     * 获取用户管理数据
     */
    fetchData() {
      // 设置加载状态
      this.loading = true;
      this.error = null;

      // 构建请求URL
      const url = '/data-serv/manager/user/list';

      // 创建取消令牌，用于在组件销毁时取消请求
      const CancelToken = this.axios.CancelToken;
      const source = CancelToken.source();
      this._axiosRequest = source;

      // 构建请求数据
      const requestData = {
        nickName: this.search.nickName,
        userName: this.search.userName,
        pageNo: this.pagination.pageNo,
        limit: this.pagination.limit,
        cancelToken: source.token,
      };

      // 使用axios获取数据
      this.axios.post(url, requestData)
        .then(response => {
          // 检查响应数据格式
          if (response.data.code === 0) {
            if (Array.isArray(response.data.data.records)) {
              this.items = response.data.data.records;
              this.filteredData = this.items;
              // 更新分页信息
              this.pagination.total = response.data.data.total || 0;
              this.pagination.pageNo = response.data.data.current || 1;
              this.pagination.limit = response.data.data.size || 10;
              
              // 如果有pages字段，可以用来验证totalPages计算
              if (response.data.data.pages) {
                // API返回的总页数可以用来验证
                this._apiPages = response.data.data.pages;
              } else {
                // 如果没有pages字段，重置_apiPages
                this._apiPages = 0;
              }
            } else {
              throw new Error('无效的数据格式');
            }
          } else {
            throw new Error(response.data.msg || '更新权限失败');
          }

        })
        .catch(error => {
          // 忽略取消请求的错误
          if (this.axios.isCancel(error)) {
            return;
          }

          console.error('获取数据失败:', error);
          this.error = error.message || '获取数据失败';

          // 显示错误提示
          if (this.$message) {
            this.$message.error(this.error);
          }

          // 清空数据
          this.items = [];
          this.filteredData = [];
        })
        .finally(() => {
          // 无论成功失败，都设置加载状态为false
          this.loading = false;
          this._axiosRequest = null;
        });
    }
  },
  mounted() {
    // 获取登录信息
    if (localStorage.getItem('userInfo')) {
      // 将用户信息从localStorage中读取
      this.loginUser = JSON.parse(localStorage.getItem('userInfo'));
    }
    // 组件挂载时获取数据
    this.fetchData();
  }
}
</script>

<style scoped>
.user-manage-container {
  padding: 20px;
}

.sticky-search {
  top: 0px;
  position: sticky;
  /* background-color: white; */
  z-index: 1001;
  padding-bottom: 10px;
  width: 100%;
  padding: 10px;
  /* border-bottom: 1px solid #eee; */
  margin-bottom: 10px;
}

.sticky-search label {
  margin-right: 5px;
  margin-left: 10px;
}

.sticky-search select,
.sticky-search input {
  margin-right: 10px;
  padding: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.sticky-search button {
  padding: 5px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.sticky-search button:hover {
  background-color: #45a049;
}

.hint-text {
  margin-bottom: 10px;
  color: #666;
  font-size: 14px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.sticky-header {
  position: sticky;
  top: 70px;
  background-color: white;
  z-index: 1000;
}

/* tbody tr:first-child td {
  position: sticky;
  top: 100px;
  height: 35px;
  z-index: 999;
  background-color: #f5f5f5;
} */

.edit-btn,
.prohibit-btn,
.change-password-btn {
  padding: 3px 10px;
  margin-right: 5px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.edit-btn {
  background-color: #1890ff;
  color: white;
}

.edit-btn:hover {
  background-color: #40a9ff;
}

.change-password-btn {
  background-color: #ff4d4f;
  color: white;
}

.change-password-btn:hover {
  background-color: #ff7875;
}

.prohibit-btn {
  transition: background-color 0.3s;
}

.enable-btn {
  background-color: #52c41a;
  color: white;
}

.enable-btn:hover {
  background-color: #73d13d;
}

.disable-btn {
  background-color: #fa8c16;
  color: white;
}

.disable-btn:hover {
  background-color: #ffad33;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 禁用用户行样式 */
.prohibited-row {
  color: #999;
}

/* 弹窗样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.dialog-body {
  padding: 20px;
  max-height: 50vh;
  overflow-y: auto;
}

.role-selection label {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
}

.checkbox-group {
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
}

.checkbox-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-item input[type="checkbox"] {
  margin-right: 8px;
  transform: scale(1.2);
}

.dialog-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.dialog-footer button {
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.dialog-footer button:first-child {
  background-color: white;
  border: 1px solid #d9d9d9;
  color: #666;
}

.dialog-footer button:first-child:hover:not(:disabled) {
  border-color: #40a9ff;
  color: #40a9ff;
}

.confirm-btn {
  background-color: #1890ff;
  border: 1px solid #1890ff;
  color: white;
}

.confirm-btn:hover:not(:disabled) {
  background-color: #40a9ff;
  border-color: #40a9ff;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.create-btn {
  margin-left: 20px;
  padding: 5px 15px;
  background-color: #52c41a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.create-btn:hover {
  background-color: #73d13d;
}

.create-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input[type="text"],
.form-group input[type="password"],
.form-group select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group input[type="text"]:focus,
.form-group input[type="password"]:focus,
.form-group select:focus {
  border-color: #40a9ff;
  outline: none;
}

/* 禁用输入框样式 */
.disabled-input {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.disabled-input:focus {
  border-color: #d9d9d9;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 15px 0;
  border-top: 1px solid #e9ecef;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-size-selector span {
  font-size: 14px;
  color: #495057;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sticky-search {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .sticky-search label,
  .sticky-search select,
  .sticky-search input,
  .form-group select {
    margin-bottom: 10px;
    width: 100%;
  }

  .sticky-search button {
    width: 100%;
  }

  .pagination-container {
    flex-direction: column;
    gap: 20px;
  }

  .page-size-selector {
    justify-content: center;
  }

  table {
    display: block;
    overflow-x: auto;
  }
}
</style>